import React, { ReactNode } from 'react';

export type PmiElementFilter = 'all' | 'fail' | 'pass';
export type PmiElementState = 'fail' | 'pass' | 'pending';

export interface PmiElementComparisonItem {
  code: string;
  rangeText: string;
  state: PmiElementState;
  stateText: string;
  valueText: string;
}

interface PmiElementComparisonProps {
  className?: string;
  filter: PmiElementFilter;
  footer?: ReactNode;
  items: PmiElementComparisonItem[];
  note?: string;
  onFilterChange: (filter: PmiElementFilter) => void;
}

const DEFAULT_NOTE = '区间来自客户技术规范 PMI Min/Max；有区间但未检出的元素按异常处理，未取得标准时只展示数值。';

function PmiElementComparison({
  className = '',
  filter,
  footer,
  items,
  note = DEFAULT_NOTE,
  onFilterChange,
}: PmiElementComparisonProps) {
  const visibleItems = items.filter((item) => filter === 'all' || item.state === filter);

  return (
    <section className={['pmi-element-page', className].filter(Boolean).join(' ')}>
      <div className="pmi-element-filter-row">
        {([
          ['all', '全部'],
          ['fail', '异常'],
          ['pass', '合格'],
        ] as Array<[PmiElementFilter, string]>).map(([nextFilter, label]) => (
          <button
            className={filter === nextFilter ? 'pmi-element-filter pmi-element-filter--active' : 'pmi-element-filter'}
            key={nextFilter}
            onClick={() => onFilterChange(nextFilter)}
            type="button"
          >
            {label}
          </button>
        ))}
      </div>

      <div className="pmi-element-list">
        {visibleItems.length ? visibleItems.map((item) => (
          <div className={`pmi-element-row pmi-element-row--${item.state}`} key={`${item.code}-${item.rangeText}`}>
            <span className="pmi-element-code">{item.code}</span>
            <span className="pmi-element-main">
              <span className="pmi-element-value">{item.valueText}</span>
              <span className="pmi-element-range">{item.rangeText}</span>
            </span>
            <span className={`pmi-element-state pmi-element-state--${item.state}`}>
              {item.stateText}
            </span>
          </div>
        )) : (
          <div className="pmi-empty">没有符合条件的元素。</div>
        )}
      </div>

      <div className="pmi-element-note">{note}</div>
      {footer ? <div className="pmi-element-footer">{footer}</div> : null}
    </section>
  );
}

export default PmiElementComparison;
